import React from 'react';
import momenttz from 'moment-timezone';

import { ILayout, ILayoutPage } from 'Module/Layout/Interface';
import { IUsers, IUsersContext, IUsersFilters, IUsersPage, IUsersResponse } from '../Interface';
import UsersPage from '../Page/index';
import { getUsersService } from '../Service/Get/index';
import { KEY_USERS_SELECTED } from 'Shared/Constant/Cache';

function UsersController(props: ILayoutPage) {
  const [contextUsers] = React.useState<IUsersContext>({ result: [] });
  const [showLoadingThisPage, setShowLoadingThisPage] = React.useState<boolean>(true);
  const [dateUpdateInfo, setDateUpdateInfo] = React.useState<string>(momenttz().tz('America/Sao_Paulo').format());
  const [filters, setFilters] = React.useState<IUsersFilters>({ rcacode: '', name: '', documentnumber: '', active: 'Todos' });

  const toggleChangeState = (field: string, value: any) => {
    switch (field) {
      case 'dateUpdateInfo':
        setDateUpdateInfo(momenttz().tz('America/Sao_Paulo').format());
        break;
      case 'showLoadingThisPage':
        setShowLoadingThisPage(value);
        setDateUpdateInfo(momenttz().tz('America/Sao_Paulo').format());
        break;
      case 'filters':
        setFilters(value);
        setDateUpdateInfo(momenttz().tz('America/Sao_Paulo').format());
        break;
      default:
        setDateUpdateInfo(momenttz().tz('America/Sao_Paulo').format());
        break;
    }
  }

  const [listUsers, setListUsers] = React.useState<[IUsers?]>([]);
  const toggleGetUsers = React.useCallback(async (filters: IUsersFilters) => {
    toggleChangeState('showLoadingThisPage', true);
    toggleChangeState('filters', filters)

    await getUsersService(filters)
      .then((response: IUsersResponse) => {
        setListUsers(response.list || []);
        toggleChangeState('showLoadingThisPage', false);
        toggleChangeState('dateUpdateInfo', '');
      })
      .catch((error: IUsersResponse) => {
        let layoutAlert: ILayout = {
          context: props.layout.context,
          titleMessage: 'Pesquisar registros',
          typeMessage: 'error',
          message: error.message,
          loading: false,
        };

        props.toggleSetLayout(layoutAlert);
        toggleChangeState('showLoadingThisPage', false);
        toggleChangeState('dateUpdateInfo', '');
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleSetUsers = (Users: IUsers, action: string) => {

  };


  React.useEffect(() => {
    toggleGetUsers(filters);
  }, [filters, toggleGetUsers]);

  React.useEffect(() => {
    let _showModal = window.location.hash.includes('#Create') ? true : false;
    toggleChangeState('showNewLeadModal', _showModal);
    if (props.toggleDelCache) {
      props.toggleDelCache(KEY_USERS_SELECTED)
    }
  }, [props])

  const handlersPage: IUsersPage = {
    ...props,
    context: contextUsers,
    listUsers,
    showLoadingThisPage,
    dateUpdateInfo,
    filters,
    itemSelected: {},
    toggleChangeState,
    toggleGetUsers,
    toggleSetUsers,
  };

  return (
    <UsersPage {...handlersPage} />
  );
}

export default UsersController;
